import { render, staticRenderFns } from "./DashboardMedal.vue?vue&type=template&id=636e42f8&"
import script from "./DashboardMedal.vue?vue&type=script&lang=js&"
export * from "./DashboardMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports